// Modules
import type {GetStaticProps} from 'next';
import {getFooterLinksPerLang} from '@app/modules/ssg-data/unlogged-data';
import {getLyricsPageGQLData} from '@app/modules/ssg-data/features/lyrics/server';
import {useTranslation} from '@app/hooks/use-translation';
import {serverSideTranslations} from '@app/modules/locale-management/server';
import {LandingSections} from '@tempo/landing';
import {TempoLandingPage} from '@app/components/layout/LandingPage';
import type {LandingProps} from '@app/types/next';
import {HiFiHero} from '@app/views/features/hifi/hero';
import {FeatureInfo} from '@app/views/features/hifi/feature-info';
import {FeatureTechnical} from '@app/views/features/hifi/feature-technical';
import {FeatureGallery} from '@app/views/features/hifi/feature-gallery';
import {FAQ} from '@app/views/features/hifi/faq';
import {FeatureMusicImage} from '@app/views/features/hifi/feature-music-image';
import {FeatureMusic} from '@app/views/features/hifi/feature-music';
import {PartnerImage} from '@app/views/features/hifi/partner-image';
import {Partner} from '@app/views/features/hifi/partner';

const HifiPage: React.FC<LandingProps> = () => {
	const {t} = useTranslation({ns: ['hifi']});
	const pageTitle = t('deezerhifilandingpage_text_seotitle_web', {
		sprintf: ['Deezer'],
	});
	const pageDescription = t('deezerhifilandingpage_text_seodescription_web', {
		sprintf: ['Deezer'],
	});

	return (
		<TempoLandingPage title={pageTitle} description={pageDescription}>
			<LandingSections topGutter>
				<HiFiHero />
				<FeatureInfo />
				<FeatureTechnical />
				<FeatureGallery />
				<Partner />
				<PartnerImage />
				<FeatureMusic />
				<FeatureMusicImage />
				<FAQ />
			</LandingSections>
		</TempoLandingPage>
	);
};

export const getStaticProps: GetStaticProps<LandingProps> = async ({
	locale = '',
	locales = [],
}) => {
	const translations = await serverSideTranslations(locale, [
		'features',
		'hifi',
		'common',
	]);
	return {
		props: {
			...translations,
			dehydratedState: {
				...(await getFooterLinksPerLang({locale, locales})),
				...(await getLyricsPageGQLData({locale})),
			},
			tracking: {
				pagecategory: 'features',
				pagename: 'hifi',
				cdpViewId: 'features_hifi',
			},
		},
		revalidate: 15 * 60,
	};
};

export default HifiPage;
